/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckMultipaxSession } from './PaxCheckMultipaxSession';
import {
    PaxCheckMultipaxSessionFromJSON,
    PaxCheckMultipaxSessionFromJSONTyped,
    PaxCheckMultipaxSessionToJSON,
    PaxCheckMultipaxSessionToJSONTyped,
} from './PaxCheckMultipaxSession';
import type { PaxCheckErrorContainer } from './PaxCheckErrorContainer';
import {
    PaxCheckErrorContainerFromJSON,
    PaxCheckErrorContainerFromJSONTyped,
    PaxCheckErrorContainerToJSON,
    PaxCheckErrorContainerToJSONTyped,
} from './PaxCheckErrorContainer';

/**
 * 
 * @export
 * @interface PaxCheckSetConsentResponse
 */
export interface PaxCheckSetConsentResponse {
    /**
     * 
     * @type {PaxCheckMultipaxSession}
     * @memberof PaxCheckSetConsentResponse
     */
    data?: PaxCheckMultipaxSession;
    /**
     * 
     * @type {PaxCheckErrorContainer}
     * @memberof PaxCheckSetConsentResponse
     */
    error?: PaxCheckErrorContainer;
}

/**
 * Check if a given object implements the PaxCheckSetConsentResponse interface.
 */
export function instanceOfPaxCheckSetConsentResponse(value: object): value is PaxCheckSetConsentResponse {
    return true;
}

export function PaxCheckSetConsentResponseFromJSON(json: any): PaxCheckSetConsentResponse {
    return PaxCheckSetConsentResponseFromJSONTyped(json, false);
}

export function PaxCheckSetConsentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckSetConsentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : PaxCheckMultipaxSessionFromJSON(json['data']),
        'error': json['error'] == null ? undefined : PaxCheckErrorContainerFromJSON(json['error']),
    };
}

export function PaxCheckSetConsentResponseToJSON(json: any): PaxCheckSetConsentResponse {
    return PaxCheckSetConsentResponseToJSONTyped(json, false);
}

export function PaxCheckSetConsentResponseToJSONTyped(value?: PaxCheckSetConsentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PaxCheckMultipaxSessionToJSON(value['data']),
        'error': PaxCheckErrorContainerToJSON(value['error']),
    };
}

